import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RouteHistoryContext } from './context';
import { PathHistoryType, RouteHistoryProviderProps } from './route-history-types';
import { getInitialHistory, setRouteHistory } from '@/local-storage/route-history/route-history';

const EXCEPTION_PATHS = ["/login", "/wallet", "/wallet/configuration", "/terms-and-conditions", "/privacy-policy"];
export const RouteHistoryProvider: React.FC<RouteHistoryProviderProps> = ({ children, defaultValues }) => {
  const location = useLocation();
  const initialHistory = getInitialHistory();
  const previousPathRef = useRef<string | null>(defaultValues?.previousPathRef?.current ?? initialHistory?.lastPath ?? null);
  const [pathHistory, setPathHistory] = useState<PathHistoryType>(defaultValues?.pathHistory ?? initialHistory);

  useEffect(() => {
    window.scrollTo(0, 0);
    const currentPath = location.pathname;
    if (EXCEPTION_PATHS.includes(currentPath)) {
      return;
    }
    const lastPath = previousPathRef.current;
    if (currentPath !== lastPath) {
      const newHistory = { currentPath, lastPath };
      setPathHistory(newHistory);
      setRouteHistory(newHistory);
      previousPathRef.current = currentPath;
    }
  }, [location.pathname]);

  const values = useMemo(()=> ({
    previousPathRef,
    pathHistory,
    setPathHistory,
  }),[previousPathRef, pathHistory])

  return (
    <RouteHistoryContext.Provider value={values}>
      {children}
    </RouteHistoryContext.Provider>
  );
};
